export const SET_ACTIVE_MODELRUN_ACTION = "SET_ACTIVE_MODELRUN_ACTION";
export const CREATE_NEW_MODELRUN_BEGIN_ACTION = "CREATE_NEW_MODELRUN_BEGIN_ACTION";
export const CREATE_NEW_MODELRUN_SUCCESS_ACTION = "CREATE_NEW_MODELRUN_SUCCESS_ACTION";
export const CREATE_NEW_MODELRUN_FAILURE_ACTION = "CREATE_NEW_MODELRUN_FAILURE_ACTION";
export const FETCH_MODELRUNS_BEGIN_ACTION = "FETCH_MODELRUNS_BEGIN_ACTION";
export const FETCH_MODELRUNS_FAILURE_ACTION = "FETCH_MODELRUNS_FAILURE_ACTION";
export const FETCH_MODELRUNS_SUCCESS_ACTION = "FETCH_MODELRUNS_SUCCESS_ACTION";
export const FETCH_MODELRUN_BY_ID_BEGIN_ACTION = "FETCH_MODELRUN_BY_ID_BEGIN_ACTION";
export const FETCH_MODELRUN_BY_ID_FAILURE_ACTION = "FETCH_MODELRUN_BY_ID_FAILURE_ACTION";
export const FETCH_MODELRUN_BY_ID_SUCCESS_ACTION = "FETCH_MODELRUN_BY_ID_SUCCESS_ACTION";
export const UPDATE_MODELRUN_BEGIN_ACTION = "UPDATE_MODELRUN_BEGIN_ACTION";
export const UPDATE_MODELRUN_SUCCESS_ACTION = "UPDATE_MODELRUN_SUCCESS_ACTION";
export const UPDATE_MODELRUN_FAILURE_ACTION = "UPDATE_MODELRUN_FAILURE_ACTION";
export const UPDATE_ACTIVE_MODELRUN_ACTION = "UPDATE_ACTIVE_MODELRUN_ACTION";
export const DELETE_MODELRUN_BEGIN_ACTION = "DELETE_MODELRUN_BEGIN_ACTION";
export const DELETE_MODELRUN_SUCCESS_ACTION = "DELETE_MODELRUN_SUCCESS_ACTION";
export const DELETE_MODELRUN_FAILURE_ACTION = "DELETE_MODELRUN_FAILURE_ACTION";
export const EXECUTE_MODELRUN_BEGIN_ACTION = "EXECUTE_MODELRUN_BEGIN_ACTION";
export const EXECUTE_MODELRUN_SUCCESS_ACTION = "EXECUTE_MODELRUN_SUCCESS_ACTION";
export const EXECUTE_MODELRUN_FAILURE_ACTION = "EXECUTE_MODELRUN_FAILURE_ACTION";
export const CREATE_MODELRUN_ASSET_BEGIN_ACTION =
  "CREATE_MODELRUN_ASSET_BEGIN_ACTION";
export const CREATE_MODELRUN_ASSET_SUCCESS_ACTION =
  "CREATE_MODELRUN_ASSET_SUCCESS_ACTION";
export const UPDATE_MODELRUN_ASSET_BEGIN_ACTION =
  "UPDATE_MODELRUN_ASSET_BEGIN_ACTION";
export const UPDATE_MODELRUN_ASSET_SUCCESS_ACTION =
  "UPDATE_MODELRUN_ASSET_SUCCESS_ACTION";  
export const TOGGLE_MODELRUN_ASSET_ACTION = "TOGGLE_MODELRUN_ASSET_ACTION";
export const DELETE_MODELRUN_ASSET_BEGIN_ACTION = "DELETE_MODELRUN_ASSET_BEGIN_ACTION";
export const DELETE_MODELRUN_ASSET_SUCCESS_ACTION = "DELETE_MODELRUN_ASSET_SUCCESS_ACTION";
export const DELETE_MODELRUN_ASSET_FAILURE_ACTION = "DELETE_MODELRUN_ASSET_FAILURE_ACTION";
export const SET_ASSET_UPLOAD_PROGRESS_ACTION = "SET_ASSET_UPLOAD_PROGRESS_ACTION";
export const ADD_ASSET_UPLOAD_CANCEL_TOKEN = "ADD_ASSET_UPLOAD_CANCEL_TOKEN"
export const REMOVE_ASSET_UPLOAD_CANCEL_TOKEN = "REMOVE_ASSET_UPLOAD_CANCEL_TOKEN"
export const RESET_COMPLETED_UPLOADS_ACTION = "RESET_COMPLETED_UPLOADS_ACTION"
export const GENERATE_RUN_BEGIN_ACTION = "GENERATE_RUN_BEGIN_ACTION";
export const GENERATE_RUN_SUCCESS_ACTION = "GENERATE_RUN_SUCCESS_ACTION";
export const GENERATE_RUN_FAILURE_ACTION = "GENERATE_RUN_FAILURE_ACTION";

// Report Runs Actions - Unified structure for reporting
export const ADD_REPORT_RUN_ACTION = "ADD_REPORT_RUN_ACTION";
export const REMOVE_REPORT_RUN_ACTION = "REMOVE_REPORT_RUN_ACTION";
export const UPDATE_REPORT_RUN_SELECTED_ASSETS_ACTION = "UPDATE_REPORT_RUN_SELECTED_ASSETS_ACTION";
export const FETCH_REPORT_MODELRUN_ASSETS_BEGIN_ACTION = "FETCH_REPORT_MODELRUN_ASSETS_BEGIN_ACTION";
export const FETCH_REPORT_MODELRUN_ASSETS_SUCCESS_ACTION = "FETCH_REPORT_MODELRUN_ASSETS_SUCCESS_ACTION";
export const FETCH_REPORT_MODELRUN_ASSETS_FAILURE_ACTION = "FETCH_REPORT_MODELRUN_ASSETS_FAILURE_ACTION";
export const RESET_MODELRUN_STATE_ACTION = "RESET_MODELRUN_STATE_ACTION"; 
export const RESET_SELECTED_MODELRUN_STATUS_ACTION = "RESET_SELECTED_MODELRUN_STATUS_ACTION";
export const UPDATE_MODELRUN_PROPS_SUCCESS_ACTION = "UPDATE_MODELRUN_PROPS_SUCCESS_ACTION";
export const FETCH_MODELRUN_TASKS_BEGIN_ACTION = "FETCH_MODELRUN_TASKS_BEGIN_ACTION";
export const FETCH_MODELRUN_TASKS_SUCCESS_ACTION = "FETCH_MODELRUN_TASKS_SUCCESS_ACTION";
export const FETCH_MODELRUN_TASKS_FAILURE_ACTION = "FETCH_MODELRUN_TASKS_FAILURE_ACTION";
export const TERMINATE_MODELRUN_TASK_BEGIN_ACTION = "TERMINATE_MODELRUN_TASK_BEGIN_ACTION";
export const TERMINATE_MODELRUN_TASK_SUCCESS_ACTION = "TERMINATE_MODELRUN_TASK_SUCCESS_ACTION";
export const TERMINATE_MODELRUN_TASK_FAILURE_ACTION = "TERMINATE_MODELRUN_TASK_FAILURE_ACTION";
export const FETCH_MODELRUN_ASSETS_BEGIN_ACTION = "FETCH_MODELRUN_ASSETS_BEGIN_ACTION";
export const FETCH_MODELRUN_ASSETS_SUCCESS_ACTION = "FETCH_MODELRUN_ASSETS_SUCCESS_ACTION";
export const FETCH_MODELRUN_ASSETS_FAILURE_ACTION = "FETCH_MODELRUN_ASSETS_FAILURE_ACTION";
export const EXECUTE_POST_PROCESSING_BEGIN_ACTION = "EXECUTE_POST_PROCESSING_BEGIN_ACTION";
export const EXECUTE_POST_PROCESSING_SUCCESS_ACTION = "EXECUTE_POST_PROCESSING_SUCCESS_ACTION";
export const EXECUTE_POST_PROCESSING_FAILURE_ACTION = "EXECUTE_POST_PROCESSING_FAILURE_ACTION";
export const GET_POSTPROCESSING_OPERATION_OVERVIEW_BEGIN_ACTION = "GET_POSTPROCESSING_OPERATION_OVERVIEW_BEGIN_ACTION";
export const GET_POSTPROCESSING_OPERATION_OVERVIEW_SUCCESS_ACTION = "GET_POSTPROCESSING_OPERATION_OVERVIEW_SUCCESS_ACTION";
export const GET_POSTPROCESSING_OPERATION_OVERVIEW_FAILURE_ACTION = "GET_POSTPROCESSING_OPERATION_OVERVIEW_FAILURE_ACTION";

export const getPostProcessingOperationOverviewBegin = () => {
  return {
    type: GET_POSTPROCESSING_OPERATION_OVERVIEW_BEGIN_ACTION,
    payload: undefined,
  }
}
export const getPostProcessingOperationOverviewSuccess = (res) => {
  return {
    type: GET_POSTPROCESSING_OPERATION_OVERVIEW_SUCCESS_ACTION,
    payload: res,
  }
} 
export const getPostProcessingOperationOverviewFailure = (message) => {
  return {
    type: GET_POSTPROCESSING_OPERATION_OVERVIEW_FAILURE_ACTION,
    payload: message,
  }
}

export const executePostProcessingBegin = () => {
  return {
    type: EXECUTE_POST_PROCESSING_BEGIN_ACTION,
    payload: undefined,
  }
}
export const executePostProcessingSuccess = (res) => {
  return {
    type: EXECUTE_POST_PROCESSING_SUCCESS_ACTION,
    payload: res,
  }
}

export const executePostProcessingFailure = (message) => {
  return {
    type: EXECUTE_POST_PROCESSING_FAILURE_ACTION,
    payload: message,   
  }
}

export const resetModelRunState = () => {
  return {
    type: RESET_MODELRUN_STATE_ACTION,
    payload: undefined
  }
}
export const updateModelRunPropsSuccess = (res) => {
  return {
    type: UPDATE_MODELRUN_PROPS_SUCCESS_ACTION,
    payload: res
  }
}

export const createNewModelRunBegin = () =>{
  return {
    type: CREATE_NEW_MODELRUN_BEGIN_ACTION,
    payload: undefined,
  }

}

export const executeModelRunBegin = () =>{
  return {
    type: EXECUTE_MODELRUN_BEGIN_ACTION,
    payload: undefined,
  }

}

export const executeModelRunSuccess = (res) =>{
  return {
    type: EXECUTE_MODELRUN_SUCCESS_ACTION,
    payload: res,
  }
}
export const executeModelRunFailure = (message) =>{
  return {
    type: EXECUTE_MODELRUN_FAILURE_ACTION,
    payload: message,
  }
}
export const terminateModelRunTaskBegin = () =>{
  return {
    type: TERMINATE_MODELRUN_TASK_BEGIN_ACTION,
    payload: undefined,
  }
}

export const terminateModelRunTaskSuccess = (res) =>{
  return {
    type: TERMINATE_MODELRUN_TASK_SUCCESS_ACTION,
    payload: res,
  }
}
export const terminateModelRunTaskFailure = (message) =>{
  return {
    type: TERMINATE_MODELRUN_TASK_FAILURE_ACTION,
    payload: message,
  }
}

  
export const fetchModelRunTasksBegin = () => {
  return {
    type: FETCH_MODELRUN_TASKS_BEGIN_ACTION,
    payload: undefined,
  };
};
export const fetchModelRunTasksSuccess = (res) => {
  return {
    type: FETCH_MODELRUN_TASKS_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchModelRunTasksFailure = (message) => {
  return {
    type: FETCH_MODELRUN_TASKS_FAILURE_ACTION,
    payload: message,
  };
};

export const fetchModelRunAssetsBegin = () => {
  return {
    type: FETCH_MODELRUN_ASSETS_BEGIN_ACTION,
    payload: undefined,
  };
};
export const fetchModelRunAssetsSuccess = (res) => {
  return {
    type: FETCH_MODELRUN_ASSETS_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchModelRunAssetsFailure = (message) => {
  return {
    type: FETCH_MODELRUN_ASSETS_FAILURE_ACTION,
    payload: message,
  };
}


export const createNewModelRunSuccess = (res) =>{
  return {
    type: CREATE_NEW_MODELRUN_SUCCESS_ACTION,
    payload: res,
  }
}
export const createNewModelRunFailure = (message) =>{
  return {
    type: CREATE_NEW_MODELRUN_FAILURE_ACTION,
    payload: message,
  }
}
export const updateModelRunBegin = () =>{
  return {
    type: UPDATE_MODELRUN_BEGIN_ACTION,
    payload: undefined,
  }

}

export const updateModelRunSuccess = (res) =>{
  return {
    type: UPDATE_MODELRUN_SUCCESS_ACTION,
    payload: res,
  }
}
export const updateModelRunFailure = (message) =>{
  return {
    type: UPDATE_MODELRUN_FAILURE_ACTION,
    payload: message,
  }
}

export const updateselectedModelRun = (modelrun) =>{
  return {
    type: UPDATE_ACTIVE_MODELRUN_ACTION,
    payload: modelrun,
  }
}
export const setselectedModelRun = (modelrun ) => {
  return {
    type: SET_ACTIVE_MODELRUN_ACTION,
    payload: modelrun
  }
}

export const resetSelectedModelRunStatus = () => {
  return {
    type: RESET_SELECTED_MODELRUN_STATUS_ACTION,
    payload: undefined
  }
}
export const fetchModelRunsBegin = () => {
  return {
    type: FETCH_MODELRUNS_BEGIN_ACTION,
    payload: undefined,
  };
};
export const fetchModelRunsSuccess = (res) => {
  return {
    type: FETCH_MODELRUNS_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchModelRunsFailure = (message) => {
  return {
    type: FETCH_MODELRUNS_FAILURE_ACTION,
    payload: message,
  };
};

export const fetchModelRunByIdBegin = (id) => {
  return {
    type: FETCH_MODELRUN_BY_ID_BEGIN_ACTION,
    payload: id,
  };
};
export const fetchModelRunByIdSuccess = (res) => {
  return {
    type: FETCH_MODELRUN_BY_ID_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchModelRunByIdFailure = (message) => {
  return {
    type: FETCH_MODELRUN_BY_ID_FAILURE_ACTION,
    payload: message,
  };
};

export const deleteModelRunBegin = () =>{
  return {
    type: DELETE_MODELRUN_BEGIN_ACTION ,
    payload: undefined
  }
}

export const deleteModelRunSuccess = (res) =>{
  return {
    type: DELETE_MODELRUN_SUCCESS_ACTION,
    payload: res
  }
}
export const deleteModelRunFailure = (message) =>{
  return {
    type: DELETE_MODELRUN_FAILURE_ACTION,
    payload: message
  }
}

export const createModelRunAssetBegin = (payload) => {
  return {
    type: CREATE_MODELRUN_ASSET_BEGIN_ACTION,
    payload: payload,
  };
};
export const createModelRunAssetSuccess = (payload) => {
  return {
    type: CREATE_MODELRUN_ASSET_SUCCESS_ACTION,
    payload: { ...payload },
  };
};

export const updateModelRunAssetBegin = (payload) => {
  return {
    type: UPDATE_MODELRUN_ASSET_BEGIN_ACTION,
    payload: { ...payload },
  };
};

export const updateModelRunAssetSuccess = (payload) => {
  return {
    type: UPDATE_MODELRUN_ASSET_SUCCESS_ACTION,
    payload: { ...payload },
  };
};

export const deleteModelRunAssetBegin = () =>{
  return {
    type: DELETE_MODELRUN_ASSET_BEGIN_ACTION ,
    payload: undefined
  }
}

export const deleteModelRunAssetSuccess = (payload) =>{
  return {
    type: DELETE_MODELRUN_ASSET_SUCCESS_ACTION,
    payload: payload
  }
}
export const deleteModelRunAssetFailure = (message) =>{
  return {
    type: DELETE_MODELRUN_ASSET_FAILURE_ACTION,
    payload: message
  }
}

export const setAssetUploadProgress = (filename, progress) => {
  return {
    type: SET_ASSET_UPLOAD_PROGRESS_ACTION,
    payload: { filename, progress }
  }
}

export const addAssetUploadCancelToken = (filename, cancelToken) => ({
  type: 'ADD_ASSET_UPLOAD_CANCEL_TOKEN',
  filename,
  cancelToken
});

export const removeAssetUploadCancelToken = (filename) => ({
  type: 'REMOVE_ASSET_UPLOAD_CANCEL_TOKEN',
  filename
});

export const resetCompletedUploads = () => ({
  type: 'RESET_COMPLETED_UPLOADS_ACTION'  
});

export const generateRunBegin = () =>{
  return {
    type: GENERATE_RUN_BEGIN_ACTION ,
    payload: undefined
  }
}

export const generateRunSuccess = (res) =>{
  return {
    type: GENERATE_RUN_SUCCESS_ACTION,
    payload: res
  }
}

export const generateRunFailure = (message) =>{
  return {
    type: GENERATE_RUN_FAILURE_ACTION,
    payload: message
  }
}

// Report Runs Action Creators - Unified structure for reporting
export const addReportRun = (reportRun) => {
  return {
    type: ADD_REPORT_RUN_ACTION,
    payload: reportRun,
  };
};

export const removeReportRun = (modelRunId) => {
  return {
    type: REMOVE_REPORT_RUN_ACTION,
    payload: modelRunId,
  };
};

export const updateReportRunSelectedAssets = (modelRunId, assetType, selectedAssets) => {
  return {
    type: UPDATE_REPORT_RUN_SELECTED_ASSETS_ACTION,
    payload: { modelRunId, assetType, selectedAssets },
  };
};

export const fetchReportModelRunAssetsBegin = () => {
  return {
    type: FETCH_REPORT_MODELRUN_ASSETS_BEGIN_ACTION,
  };
};

export const fetchReportModelRunAssetsSuccess = (res) => {
  return {
    type: FETCH_REPORT_MODELRUN_ASSETS_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchReportModelRunAssetsFailure = (message) => {
  return {
    type: FETCH_REPORT_MODELRUN_ASSETS_FAILURE_ACTION,
    payload: message,
  };
};